import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { EduCompanyListTable } from "./edu-company-list-table";
import { EduCompanyAdd } from "./edu-company-add";
import { use } from "react";
import { EduCompanyEdit } from "./edu-company-edit";
import { EduCompanyArchiveList } from "./edu-company-archive-list";

export const EduCompanyHome = () => {
  let loginUser = JSON.parse(localStorage.getItem("user"));
  const [userType, setUserType] = useState(loginUser?.user_type);
  const [archivedVal, setArchivedVal] = useState("Archived");
  const [activateEduCompanyAdd, setActivateEduCompanyAdd] = useState(false);
  const [activateEduCompanyEdit, setActivateEduCompanyEdit] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [companyData, setCompanyData] = useState([]);

  // Add state for tab management like bus portal
  const [tabSelected, setTabSelected] = useState("company");
  const [companyCount, setCompanyCount] = useState(0);
  const [archiveCount, setArchiveCount] = useState(0);

  // Add state for archive pagination
  const [pageNumberArchive, setPageNumberArchive] = useState(1);
  const [pageLimitArchive, setPageLimitArchive] = useState(10);

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="d-flex w-full flex-row align-items-center justify-content-between">
            <div>
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <i className="fa fa-building me-2" />
                  Company Management
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/"> Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Company Management
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <Link
              role="button"
              className="blu-btn"
              data-bs-toggle="modal"
              data-bs-target="#add-company"
              onClick={() => setActivateEduCompanyAdd(true)}
            >
              <i className="fa fa-plus me-2" />
              Add
            </Link>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="cstm-tab">
            <ul className="nav" id="myTab">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    tabSelected === "company" ? "active" : ""
                  }`}
                  data-bs-toggle="tab"
                  data-bs-target="#tab-01"
                  type="button"
                  role="tab"
                  onClick={() => {
                    setArchivedVal("Archived");
                    setTabSelected("company");
                  }}
                >
                  Company List &nbsp; ({companyCount})
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    tabSelected === "archive" ? "active" : ""
                  }`}
                  data-bs-toggle="tab"
                  data-bs-target="#tab-02"
                  type="button"
                  role="tab"
                  onClick={() => {
                    setArchivedVal("Restore");
                    setTabSelected("archive");
                  }}
                >
                  Archive List &nbsp; ({archiveCount})
                </button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className={`tab-pane fade ${
                  tabSelected === "company" ? "show active" : ""
                }`}
                id="tab-01"
                role="tabpanel"
              >
                <EduCompanyListTable
                  userType={userType}
                  activateEduCompanyEdit={activateEduCompanyEdit}
                  setActivateEduCompanyEdit={setActivateEduCompanyEdit}
                  forceUpdate={forceUpdate}
                  setForceUpdate={setForceUpdate}
                  setCompanyData={setCompanyData}
                  setCompanyCount={setCompanyCount}
                />
              </div>
              <div
                className={`tab-pane fade ${
                  tabSelected === "archive" ? "show active" : ""
                }`}
                id="tab-02"
                role="tabpanel"
              >
                <EduCompanyArchiveList
                  userType={userType}
                  forceUpdate={forceUpdate}
                  setForceUpdate={setForceUpdate}
                  pageNumberArchive={pageNumberArchive}
                  setPageNumberArchive={setPageNumberArchive}
                  pageLimitArchive={pageLimitArchive}
                  setPageLimitArchive={setPageLimitArchive}
                  setArchiveCount={setArchiveCount}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EduCompanyAdd
        userType={userType}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        activateEduCompanyAdd={activateEduCompanyAdd}
        setActivateEduCompanyAdd={setActivateEduCompanyAdd}
      />
      <EduCompanyEdit
        userType={userType}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        activateEduCompanyEdit={activateEduCompanyEdit}
        setActivateEduCompanyEdit={setActivateEduCompanyEdit}
        companyData={companyData}
      />
    </section>
  );
};
